export const servicesList = [
      {
        id: 1,
        serviceName: "Labour Outsourcing",
        link: 'Labour Outsourcing',
        description: "Whether you have an in-house HR team or none at all, our effective HR support ensures your business stays compliant and efficient. Our team of highly qualified professionals is available 24/7 to provide unlimited, untimed expert advice.",
        services: [
          { id: 1, name: "Contract management solutions" },
          { id: 2, name: "Labor relations" },
          { id: 3, name: "Payroll management" },
          { id: 4, name: "Recruitment and Placement" },
          { id: 5, name: "Compliance" }
        ]
      },
      {
        id: 2,
        serviceName: "Recruitment and Placement",
        link: '#recruitment-labour',
        description: "Finding the right talent is crucial for business success. We understand your needs and connect you with candidates that align with your business goals. With our extensive network, you gain access to a large pool of qualified candidates, making the hiring process seamless and efficient.",
        services: [
          { id: 1, name: "Extensive Network of Qualified Candidates" },
          { id: 2, name: "Streamlined Hiring Process" },
          { id: 3, name: "Expert Guidance and Support" },
          { id: 4, name: "Commitment to Quality and Excellence" }
        ]
      },
      {
        id: 3,
        serviceName: "Expert HR Advisory & Solutions",
        link: '#advisory-labour',
        description: "Hillrock Resource Advisory (HRA), comprising of a pool of sector experts will help your organization navigate complex HR challenges and provide tailored solutions based on the organization’s unique needs.",
        services: [
          { id: 1, name: "HR Policies and Frameworks" },
          { id: 2, name: "Risk Management and Compliance" },
          { id: 3, name: "Change Management" },
          { id: 4, name: "HR Audits" },
          { id: 5, name: "Performance Management" },
          { id: 6, name: "Baseline Surveys" },
          { id: 7, name: "Employee Counselling Services" }
        ]
      },
      {
        id: 4,
        serviceName: "Training & Development",
        link: "#service-training",
        "description": "Empower your team with our comprehensive training and development programs. We offer customized solutions to enhance skills, boost productivity, and foster a culture of continuous learning.",
        "services": []
      }
    ]
  
  